module.exports = __webpack_public_path__ + "img/V7.176c023d.jpg";